import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SHIPPED_VIEW_ID } from './view-id-constants';
import { DEFAULT_SHIPMENTS_PAGE_URL } from '../../../services/user-permission-service';

export const Shipped = {
  label: <FormattedMessage defaultMessage='Shipped' description='ordersPage.nav.shipped' id='qeM+7N' />,
  id: SHIPPED_VIEW_ID,
  navigationOverride: DEFAULT_SHIPMENTS_PAGE_URL,
};
